var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "discussion" }, [
    _c("div", { staticClass: "discussion-user" }, [
      _vm.discussionuser &&
      _vm.discussionuser.body &&
      _vm.discussionuser.body.user &&
      _vm.discussionuser.body.user.picture
        ? _c("img", {
            staticClass: "discussion-user-image",
            attrs: { src: _vm.discussionuser.body.user.picture.data.url },
          })
        : _vm._e(),
      _vm._v(
        "\n    " +
          _vm._s(
            _vm.discussionuser &&
              _vm.discussionuser.body &&
              _vm.discussionuser.body.user &&
              _vm.discussionuser.body.user.name
              ? _vm.discussionuser.body.user.name
              : _vm.discussion.body.conversation.participants.data.find(
                  (participant) => participant.username != _vm.page.name
                ).username
          ) +
          "\n  "
      ),
    ]),
    _c(
      "ul",
      { staticClass: "discussion-order scrollable" },
      _vm._l(_vm.discussion.body.discussion.data, function (discut, key) {
        return _c("li", { key: key }, [
          _c(
            "div",
            {
              on: {
                dblclick: function ($event) {
                  return _vm.reactToMessage(discut.id, discut)
                },
              },
            },
            [
              discut.from.id != _vm.page.network_id
                ? _c("div", { staticClass: "message-received" }, [
                    _c("div", { staticClass: "message-received-image" }, [
                      _vm.discussionuser &&
                      _vm.discussionuser.body &&
                      _vm.discussionuser.body.user &&
                      _vm.discussionuser.body.user.picture
                        ? _c("img", {
                            staticClass: "message-received-image",
                            attrs: {
                              src: _vm.discussionuser.body.user.picture.data
                                .url,
                            },
                          })
                        : discut.from.username != _vm.page.name
                        ? _c("span", [
                            _vm._v(_vm._s(discut.from.name.charAt(0))),
                          ])
                        : _vm._e(),
                    ]),
                    _c("div", { staticClass: "message-received-content" }, [
                      _c(
                        "div",
                        {
                          class: _vm.getInstagram
                            ? "message-received-content-text-instagram"
                            : "message-received-content-text",
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(discut.message) +
                              "\n              "
                          ),
                          discut.attachments
                            ? _c("div", [
                                _c("img", {
                                  staticClass: "message-received-content-image",
                                  attrs: {
                                    src: discut.attachments.data[0].image_data
                                      .url,
                                  },
                                }),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      discut.reactions && _vm.page.network == "instagram"
                        ? _c("div", [
                            discut.reactions.data[0].reaction == "love"
                              ? _c("div", { staticClass: "message-loved" }, [
                                  _c("img", {
                                    staticClass: "circle",
                                    attrs: {
                                      id: "lovesvg",
                                      src: require("../../assets/img/icon_heart_full_red.svg"),
                                    },
                                  }),
                                ])
                              : _vm._e(),
                          ])
                        : _vm._e(),
                    ]),
                  ])
                : _vm._e(),
              discut.from.name == _vm.page.name
                ? _c("div", { staticClass: "message-sent" }, [
                    _c("div", { staticClass: "message-sent-content" }, [
                      _c(
                        "div",
                        {
                          class: _vm.getInstagram
                            ? "message-sent-content-text-instagram"
                            : "message-sent-content-text",
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(discut.message) +
                              "\n              "
                          ),
                          discut.attachments
                            ? _c("div", [
                                typeof discut.attachments.data[0].image_data !=
                                "undefined"
                                  ? _c("img", {
                                      staticClass:
                                        "message-received-content-image",
                                      attrs: {
                                        src: discut.attachments.data[0]
                                          .image_data.url,
                                      },
                                    })
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      discut.reactions && _vm.page.network == "instagram"
                        ? _c("div", [
                            discut.reactions.data[0].reaction == "love"
                              ? _c("div", { staticClass: "message-loved" }, [
                                  _c("img", {
                                    staticClass: "circle",
                                    attrs: {
                                      id: "lovesvg",
                                      src: require("../../assets/img/icon_heart_full_red.svg"),
                                    },
                                  }),
                                ])
                              : _vm._e(),
                          ])
                        : _vm._e(),
                      _vm.page.network == "instagram" ||
                      (_vm.page.network == "facebook" &&
                        discut.tags &&
                        discut.tags.data[2].name == "sent")
                        ? _c("div", [
                            _c("img", {
                              staticClass: "message-sent-sended",
                              attrs: {
                                src: require("../../assets/img/icon_round_check.svg"),
                              },
                            }),
                          ])
                        : _vm._e(),
                    ]),
                  ])
                : _vm._e(),
            ]
          ),
        ])
      }),
      0
    ),
    this.url.length != 0
      ? _c("div", { staticClass: "discussion-preview-div" }, [
          _c(
            "ul",
            { staticClass: "discussion-preview" },
            _vm._l(_vm.url, function (item, key) {
              return _c("li", { key: key }, [
                _c("img", {
                  staticClass: "discussion-preview-image",
                  attrs: { src: item },
                }),
              ])
            }),
            0
          ),
          _c("button", {
            staticClass: "discussion-preview-delete",
            on: { click: _vm.clearInputFile },
          }),
        ])
      : _vm._e(),
    _c(
      "form",
      {
        attrs: { id: "send", method: "post" },
        on: {
          submit: _vm.onSubmitMessage,
          keyup: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            return _vm.onSubmitMessage.apply(null, arguments)
          },
        },
      },
      [
        _c("div", { staticClass: "discussion-answer" }, [
          _c("label", { staticClass: "uploadFile" }, [
            _c("img", {
              attrs: { src: require("../../assets/img/icon_paperclip.svg") },
            }),
            _c("input", {
              staticClass: "inputfile form-control",
              attrs: {
                type: "file",
                id: "attachment",
                name: "attachment",
                accept: "video/*, image/*",
              },
              on: { change: _vm.previewFiles },
            }),
          ]),
          _c("div", { staticClass: "answear-zone" }, [
            _c(
              "div",
              { staticClass: "textarea-emoji-picker" },
              [
                _c("picker", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showEmojiPicker,
                      expression: "showEmojiPicker",
                    },
                  ],
                  attrs: {
                    data: _vm.emojiIndex,
                    title: "Pick your emoji...",
                    emoji: "point_up",
                  },
                  on: { select: _vm.addEmoji },
                }),
                _c(
                  "span",
                  {
                    staticClass: "emoji-trigger",
                    class: { triggered: _vm.showEmojiPicker },
                    on: {
                      click: function ($event) {
                        return _vm.toggleEmojiPicker()
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticStyle: { width: "20px", height: "20px" },
                        attrs: { viewBox: "0 0 24 24" },
                      },
                      [
                        _c("path", {
                          attrs: {
                            fill: "#888888",
                            d: "M20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M10,9.5C10,10.3 9.3,11 8.5,11C7.7,11 7,10.3 7,9.5C7,8.7 7.7,8 8.5,8C9.3,8 10,8.7 10,9.5M17,9.5C17,10.3 16.3,11 15.5,11C14.7,11 14,10.3 14,9.5C14,8.7 14.7,8 15.5,8C16.3,8 17,8.7 17,9.5M12,17.23C10.25,17.23 8.71,16.5 7.81,15.42L9.23,14C9.68,14.72 10.75,15.23 12,15.23C13.25,15.23 14.32,14.72 14.77,14L16.19,15.42C15.29,16.5 13.75,17.23 12,17.23Z",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
                _c("vs-textarea", {
                  ref: "inputmessage",
                  staticClass: "answer-text",
                  attrs: { id: "textmessage", height: "80px", width: "100%" },
                  model: {
                    value: _vm.message,
                    callback: function ($$v) {
                      _vm.message = $$v
                    },
                    expression: "message",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }